import { Page } from '@/core/architecture'

import { CollectionItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * CollectionItemDetail Page
 * Implemented as a practical sample.
 */
export const CollectionItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <CollectionItemDetailTemplate state={state} {...actions} />
}
